import { computed, makeObservable } from 'mobx';
import { get as _get } from 'lodash';
import { getRoot } from 'mobx-easy';
import RootStore from '../root-store';
import { ApiVersion } from '@bringg/types';
import { OldSharedLocationConfig } from '../../types/shared-location.types';

abstract class BaseCustomerExperienceStoreType<T> {
	constructor() {
		makeObservable(this, {
			customerExperience: computed
		});
	}

	get customerExperience(): T {
		switch ((getRoot() as RootStore).apiVersion) {
			case ApiVersion.V1:
				return _get(getRoot(), 'sharedLocationStore.sharedLocationConfig') as T;
			case ApiVersion.V2:
				return _get(getRoot(), 'customerExperienceStore.customerExperience') as T;
			default:
				throw new Error('Api version not supported');
		}
	}

	// will initialize realtime subscriptions in the future in initialize pre shared location
	abstract initialize();

	abstract dispose();

	serializeToV2(oldSharedLocationConfig: OldSharedLocationConfig): any {
		return oldSharedLocationConfig;
	}
}

export default BaseCustomerExperienceStoreType;
